import { render, staticRenderFns } from "./markup.vue?vue&type=template&id=6985a0e4&"
import script from "./markup.vue?vue&type=script&lang=js&"
export * from "./markup.vue?vue&type=script&lang=js&"
import style0 from "./markup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports